export const GridId = 'recidivrapportering';
export const ConfigName = 'recidivrapportering';
export const ModuleName = 'recidivrapportering';
export const TableName = 'Recidivrapportering';
export const DisplayName = 'Recidivrapp.';
